import type { MilestoneScope } from "@/views/PlanOfRecord/planOfRecordData";

const SCOPE_META: Record<MilestoneScope, { label: string; className: string }> =
  {
    study: { label: "Study", className: "bg-[#E8EAF6] text-[#3949AB]" },
    country: { label: "Country", className: "bg-[#E0F2F1] text-[#00695C]" },
    site: { label: "Site", className: "bg-[#FCE4EC] text-[#AD1457]" },
  };

export function ScopeBadge({ scope }: { scope: MilestoneScope }) {
  const meta = SCOPE_META[scope];

  return (
    <span
      className={`inline-flex h-5 items-center rounded-[4px] px-1.5 text-[12px] font-semibold ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
